import { defineStore } from 'pinia';
import { Configurator, IQueryResponse, IServiceOptions } from '@wyocrm/sdk';
import { ITransaction, IFileUploadRequest, TerminalServices, ICustomerOptions, ICustomer, IOrder } from '@wyocrm/sdk';
import { QueryBuilder } from '@litepos/autoquery';


export const useWyoSdkStore = defineStore('wyo', {
  state: () => ({
    isInitialized: false
  }),
  actions: {
    async getWyoService(): Promise<TerminalServices> {
     if(!this.isInitialized) throw new Error('Wyo service is not initialized');
     return new TerminalServices();
    },
    async initWyoService(options: IServiceOptions){
      Configurator.initialize(options);
      this.isInitialized = true;
    },
    async queryCustomers(params: QueryBuilder<ICustomer>, keyword?: string) : Promise<IQueryResponse<ICustomer>> {
      const service = await this.getWyoService();
      return service.queryCustomers(params, keyword);
    },
    // async searchCustomers(keyword: string, params?: QueryBuilder<ICustomer>) {
    //   return service?.searchCustomers(keyword, params);
    // },
    async createCustomer(options: ICustomerOptions) {
      const service = await this.getWyoService();
      return service.createCustomer(options);
    },
    async updateCustomer(customerId: number, options: ICustomerOptions) {
      const service = await this.getWyoService();
      return service.updateCustomer(customerId, options);
    },
    async queryTransactions(query: QueryBuilder<ITransaction>) {
      const service = await this.getWyoService();
      return service.queryTransactions(query);
    },
    async queryOrders(query: QueryBuilder<IOrder>) : Promise<IQueryResponse<IOrder>> {
      const service = await this.getWyoService();
      return await service.queryOrders(query);
    },
    async getCouponsByCustomerId(id: number) {
      const service = await this.getWyoService();
      const response = await service.getCouponsByCustomerId(id);

      // Convert percentage values to decimal for easier calculation
      if (response && response.data && Array.isArray(response.data)) {
        response.data.forEach((coupon: any) => {
          if (coupon.coupon.discount_calc_type === 2) {
            // Convert percentage to decimal (e.g., 10 -> 0.1)
            coupon.coupon.discount_percent = coupon.coupon.discount_percent * 0.01;
          }
        });
      }

      return response;
    },
    async deleteCustomer(id: number) {
      const service = await this.getWyoService();
      return service.deleteCustomer(id);
    },
    async uploadFile(id: number, file: IFileUploadRequest) {
      const service = await this.getWyoService();
      return service.uploadCustomerPhoto(id, file);
    },
  },
});
